// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__HdJIx","label":"Section_label__kXeSM","contentWrap":"Section_contentWrap__2p1Ml","footer":"Section_footer__1kDPR","footerInner":"Section_footerInner__2kRt5"};